import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
  api_url: null,
  authToken: null,
  clientToken: null,
  expiresIn: null,
  pdv: null,
  pos: null,
  loginError: null,
  isGuestBuyer: false,
  signSteps: {
    logged: false,
    signForm: true,
    step: 0,
  },
  userBilletProps: {
    payer_doc: '',
    installmentsBillet: 1,
    payer_name: '',
  },
  userProps: {
    clientID: null,
    email: '',
    name: '',
    lastname: '',
    ddi: '55',
    country: '',
    notBrazillian: false,
    document: '',
    phone: '',
    ddd: '',
    password: '',
  },
  storeConfigs: null,
  loginPosData: null,
  store: null,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
